import { clsx } from 'clsx';
import { useRef } from 'react';

import { RegionBadge } from '@/components/shared/RegionBadge/RegionBadge.tsx';
import { useAuthStore, useChosenNumberStore } from '@/store';
import { ChosenNumber } from '@/types';

import cn from './styles.module.sass';

interface INumberCardProps {
    number: string;
    region: string;
    onClick: (chosenNumber: Partial<ChosenNumber>) => void;
    chosenObj: Partial<Omit<ChosenNumber, 'number' | 'region'>>;
    minTariffPrice: number;
    tariffs: string[];
    tariffId: string;
}

export const NumberCard = ({
    number,
    region,
    onClick,
    chosenObj,
    minTariffPrice,
    tariffs,
    tariffId,
}: INumberCardProps) => {
    const { isAuth } = useAuthStore();
    const { activeTariffBlockRef, setActiveTariffBlockRef, clearOnUnmount, setActiveTariffSid } =
        useChosenNumberStore();
    const numberCardRef = useRef<HTMLDivElement>(null);

    const handleClick = () => {
        onClick({ ...chosenObj, number, region, price: minTariffPrice, tariffs });
        setActiveTariffBlockRef(activeTariffBlockRef === numberCardRef ? null : numberCardRef);
        setActiveTariffSid(tariffId);

        if (activeTariffBlockRef === numberCardRef) {
            clearOnUnmount();
        }
    };

    return (
        <div
            ref={numberCardRef}
            onClick={handleClick}
            className={clsx(
                cn.numberCard,
                activeTariffBlockRef === numberCardRef && isAuth && cn.active
            )}
        >
            <span className={cn.number}>{number}</span>
            <RegionBadge region={region} />
        </div>
    );
};
